document.addEventListener("scroll", function () {
      // pp slider start
    var ddBottomSwiper = new Swiper(".dd-swiperBottom", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        on: {
            init: function () {
                previousActiveIndex = this.activeIndex;
            },
            click: function () {
                // console.log("this.activeIndex",this.activeIndex)
                // console.log("this.clickedIndex",this.clickedIndex)
                // console.log("previousActiveIndex",previousActiveIndex)

                if (this.clickedIndex < previousActiveIndex) {
                    // console.log("Left");
                    this.slideTo(this.clickedIndex - 1, 300, true);
                    // console.log(this.clickedIndex - 1);
                } else {
                    this.slideTo(this.clickedIndex, 300, true);
                }
                previousActiveIndex = this.clickedIndex;
                // console.log("-----------",)
            },
        },
    });

    var ddTopSwiper = new Swiper(".dd-swiperTop", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: ddBottomSwiper,
        },
    });

    if (ddBottomSwiper) {
        let ppthumbImages = document.querySelectorAll(".dd-swiperBottom .swiper-wrapper img");
        if (ppthumbImages) {
            ppthumbImages.forEach(item => {
                item.style.width = "100%";
            })
        }
    }
    // pp slider end
     // pp slider mobile start
    var ddBottomSwiper = new Swiper(".dd-swiperBottomMobile", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        on: {
            init: function () {
                previousActiveIndex = this.activeIndex;
            },
            click: function () {
                // console.log("this.activeIndex",this.activeIndex)
                // console.log("this.clickedIndex",this.clickedIndex)
                // console.log("previousActiveIndex",previousActiveIndex)

                if (this.clickedIndex < previousActiveIndex) {
                    // console.log("Left");
                    this.slideTo(this.clickedIndex - 1, 300, true);
                    // console.log(this.clickedIndex - 1);
                } else {
                    this.slideTo(this.clickedIndex, 300, true);
                }
                previousActiveIndex = this.clickedIndex;
                // console.log("-----------",)
            },
        },
    });

    var ddTopSwiper = new Swiper(".dd-swiperTopMobile", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: ddBottomSwiper,
        },
    });

    if (ddBottomSwiper) {
        let ppthumbImages = document.querySelectorAll(".dd-swiperBottomMobile .swiper-wrapper img");
        if (ppthumbImages) {
            ppthumbImages.forEach(item => {
                item.style.width = "100%";
            })
        }
    }
    // pp mobile slider end
  const fadeElements = document.querySelectorAll(".fade-in");
  fadeElements.forEach((element) => {
    const position = element.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;

    // Eğer element ekranın görünür alanına girdiyse animasyonu tetikle
    if (position < screenHeight) {
      element.classList.add("visible");
    }
  });
  const scrollY = window.scrollY;
  const screenHeight = window.innerHeight;
  const atcButton = document.querySelector(".mobileatc");

  // Ekran yüksekliği 200vh'i geçtikten sonra "sticky" özelliğini ekle
  if (scrollY > 1.5 * screenHeight) {
    atcButton.classList.add("sticky");
    atcButton.classList.remove("atcnone");
  } else {
    atcButton.classList.add("atcnone");
  }
});
